import { useEffect, useState } from 'react';
import { SecurityBondingLayout } from '../../components/security/SecurityBondingLayout';

/**
 * SecuritySuccessPage — Tela final de sucesso após aprovação do bonding.
 * Exibe confirmação visual e fecha automaticamente em 5 segundos.
 *
 * Doc: docs_autentica_seguranca_hard/05-mapa-integracao-componentes.md
 * Rota: /security/success (pública)
 */
export default function SecuritySuccessPage() {
  const [segundos, setSegundos] = useState(5);

  useEffect(() => {
    const interval = setInterval(() => {
      setSegundos(s => {
        if (s <= 1) {
          clearInterval(interval);
          // Em PWA standalone, window.close() não funciona — redirecionar
          const isStandalone = window.matchMedia('(display-mode: standalone)').matches
            || (window.navigator as any).standalone === true;
          if (isStandalone) {
            window.location.href = '/mobile';
          } else {
            window.close();
            // Fallback se close() falhar (ex: aba normal que não foi aberta por script)
            setTimeout(() => { window.location.href = '/mobile'; }, 500);
          }
          return 0;
        }
        return s - 1;
      });
    }, 1000);
    return () => clearInterval(interval);
  }, []);

  return (
    <SecurityBondingLayout>
      <div style={{
        flex: 1, display: 'flex', flexDirection: 'column',
        alignItems: 'center', justifyContent: 'center', textAlign: 'center', gap: '1.5rem',
      }}>
        {/* Ícone animado */}
        <div style={{
          width: 100, height: 100, borderRadius: '50%',
          background: 'linear-gradient(135deg, rgba(16,185,129,0.2), rgba(16,185,129,0.05))',
          border: '2px solid rgba(16,185,129,0.4)',
          display: 'flex', alignItems: 'center', justifyContent: 'center',
          fontSize: '3.5rem',
          animation: 'bounceIn 0.6s ease',
        }}>
          ✅
        </div>

        <div>
          <h1 style={{ fontSize: '1.6rem', fontWeight: 800, color: '#f8fafc', marginBottom: '0.5rem' }}>
            Acesso Autorizado!
          </h1>
          <p style={{ fontSize: '0.95rem', color: '#10b981', fontWeight: 600 }}>
            Identidade confirmada com sucesso
          </p>
        </div>

        <div style={{
          padding: '1rem 1.5rem', borderRadius: 16,
          background: 'rgba(16,185,129,0.08)', border: '1px solid rgba(16,185,129,0.2)',
          maxWidth: 300,
        }}>
          <p style={{ fontSize: '0.88rem', color: '#94a3b8', lineHeight: 1.6 }}>
            O computador foi liberado com segurança máxima. Você pode fechar esta página.
          </p>
        </div>

        {/* Lista de verificações */}
        {['Identidade Google verificada', 'Biometria confirmada', 'Localização validada', 'Código de segurança aprovado'].map((item, i) => (
          <div key={i} style={{
            display: 'flex', alignItems: 'center', gap: 10, width: '100%', maxWidth: 280,
          }}>
            <div style={{
              width: 20, height: 20, borderRadius: '50%', flexShrink: 0,
              background: 'rgba(16,185,129,0.2)',
              display: 'flex', alignItems: 'center', justifyContent: 'center',
              fontSize: '0.7rem', color: '#10b981',
            }}>✓</div>
            <span style={{ fontSize: '0.85rem', color: '#94a3b8' }}>{item}</span>
          </div>
        ))}

        <p style={{ fontSize: '0.78rem', color: '#475569', marginTop: '1rem' }}>
          Fechando automaticamente em {segundos}s...
        </p>
      </div>
    </SecurityBondingLayout>
  );
}
